import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            width={30}
            height={31}
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1842_716)">
                <mask
                    id="a"
                    style={{
                        maskType: 'luminance',
                    }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={30}
                    height={31}
                >
                    <path d="M30 0H0v30.001h30V0z" fill="#fff" />
                </mask>
                <g mask="url(#a)">
                    <path
                        d="M17.611 28.862l-5.209-5.215 11.19-11.303 5.304 5.304L17.61 28.862z"
                        fill="#8AB4F8"
                    />
                    <path
                        d="M17.649 6.403l-5.304-5.305L1.1 12.344a3.748 3.748 0 00-.002 5.301l.002.003 11.246 11.245 5.203-5.227-8.498-8.663 8.599-8.6z"
                        fill="#4285F4"
                    />
                    <path
                        d="M28.894 12.344L17.65 1.098a3.75 3.75 0 00-5.305 5.304l11.252 11.246a3.75 3.75 0 105.303-5.304h-.005z"
                        fill="#8AB4F8"
                    />
                    <path
                        d="M14.956 30.003a3.717 3.717 0 100-7.434 3.717 3.717 0 000 7.434z"
                        fill="#246FDB"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_1842_716">
                    <path fill="#fff" d="M0 0H30V31H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgComponent;
